import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CodaltComponent } from 'src/app/codalt.component';
import { AuthService } from 'src/app/services/auth/auth.service';
import { LocalStorage } from 'src/app/storage.class';
import { Utils } from 'src/app/utils.class';

@Component({
    selector: 'app-microsoft-callback',
    templateUrl: './microsoft-callback.component.html',
    styleUrls: ['./microsoft-callback.component.scss'],
    standalone: false,
})
export class MicrosoftCallbackComponent extends CodaltComponent implements OnInit {
    errorMessage: string | null = null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService
    ) {
        super();
    }

    ngOnInit() {
        this.route.queryParams.subscribe(
            (params: { error?: string; code?: string; state?: string; session_state?: string }) => {
                this.subscriptions.add(
                    this.authService.handleMicrosoftCallback(params.code, params.state).subscribe(
                        authResponse => {
                            LocalStorage.setUserToken(authResponse.access_token);
                            LocalStorage.setUser(authResponse.user);
                            this.router.navigateByUrl(Utils.getStartPage());
                        },
                        error => {
                            this.errorMessage = error.message;
                        }
                    )
                );
            }
        );
    }
}
